"use client";
import { jsx } from "react/jsx-runtime";
import { Dialog } from "@base-ui/react/dialog";
import { Drawer } from "@base-ui/react/drawer";
import { forwardRef, useMemo, useState } from "react";
import { PortalContainerProvider } from "../../contexts/index.js";
import { cn } from "../../utils/cn.js";
import { mergeRefs } from "../../utils/mergeRefs.js";
import { dialogVariants } from "./Dialog.variants.js";
import { useDialogMode } from "./DialogContext.js";
const DialogPopup_DialogPopup = /*#__PURE__*/ forwardRef(function({ className, size, slots, children, ...props }, ref) {
    const mode = useDialogMode();
    const { popup, drawerPopup, viewport } = dialogVariants({
        size
    });
    const [container, setContainer] = useState(null);
    const mergedRef = useMemo(()=>mergeRefs(ref, setContainer), [
        ref
    ]);
    if ('drawer' === mode) {
        const { finalFocus: _finalFocus, initialFocus: _initialFocus, ...drawerProps } = props;
        const drawerPopupClasses = cn(drawerPopup(), className, slots?.popup);
        return /*#__PURE__*/ jsx(Drawer.Viewport, {
            className: cn(viewport(), slots?.viewport),
            children: /*#__PURE__*/ jsx(Drawer.Popup, {
                ref: mergedRef,
                "data-mode": "drawer",
                className: drawerPopupClasses,
                ...drawerProps,
                children: /*#__PURE__*/ jsx(PortalContainerProvider, {
                    container: container,
                    children: children
                })
            })
        });
    }
    const popupClasses = cn(popup(), className, slots?.popup);
    return /*#__PURE__*/ jsx(Dialog.Popup, {
        ref: mergedRef,
        "data-mode": "dialog",
        className: popupClasses,
        ...props,
        children: /*#__PURE__*/ jsx(PortalContainerProvider, {
            container: container,
            children: children
        })
    });
});
export { DialogPopup_DialogPopup as DialogPopup };
